<template>
  <div>
    <!-- Bouton pour afficher/masquer le lecteur -->
<button @click="isVisible = !isVisible"
  class="fixed bottom-1 md:bottom-4 right-2 md:right-4 
         group flex items-center 
          text-white px-3 md:px-5 py-1 md:py-2 
         rounded-full hover:shadow-lg 
         transition-all duration-500 
         text-xs md:text-sm font-medium 
          hover:blur-none hover:bg-black/80">
  <span class="hidden group-hover:block pr-3">
    {{ isVisible ? 'Masquer' : 'Musique ' }}
  </span>
  <span>🎵</span>
</button>


    <!-- Lecteur Audio -->
    <div v-if="isVisible"
      class="fixed bottom-14 right-4 w-64 bg-white/90 backdrop-blur-md shadow-2xl rounded-3xl p-4 flex flex-col items-center space-y-3 transition-all duration-300">

      <!-- Titre défilant -->
      <div class="w-full overflow-hidden relative h-6 ">
        <div ref="marquee" class="whitespace-nowrap absolute font-semibold text-[#FF9900]  animate-marquee"
          :style="{ animationDuration: duration + 's' }">
          {{ currentSong?.title || '...' }}
        </div>
      </div>

      <!-- Contrôles -->
      <div class="flex items-center justify-center space-x-6">
        <button class="text-gray-500 hover:text-black" @click="prevSong">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <button @click="togglePlayPause"
          class="bg-[#FF9900] text-white p-3 rounded-full hover:scale-105 active:scale-95 transition-transform">
          <svg v-if="!isPlaying" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3l14 9-14 9V3z" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 19V5h4v14H6zm8 0V5h4v14h-4z" />
          </svg>
        </button>

        <button class="text-gray-500 hover:text-black" @click="nextSong">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isPlaying: false,
      isVisible: false,
      currentSong: null,
      audio: null,
      duration: 12,  // Durée de l'animation du titre
    };
  },
  mounted() {
    this.loadFirstSong();   
  },
  methods: {
    loadFirstSong() {
      this.axios.get(this.requestHttp+'first-audio', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        }
      }).then(({ data }) => {
        if (data.success) {
          this.currentSong = data.data;
          this.initAudio();
        } else {
          console.error('Erreur lors du chargement de la première chanson');
        }
      }).catch(error => {
        console.error('Erreur lors du chargement de la première chanson:', error);
      });
    },

    // Initialiser l'audio avec la chanson actuelle
    initAudio() {
      if (this.audio) {
        this.audio.pause();
        this.audio = null;
      }
      this.audio = new Audio(this.currentSong.path);
      this.audio.addEventListener('ended', this.nextSong); // Passer à la chanson suivante à la fin
    },

    // Jouer ou mettre en pause la chanson
    togglePlayPause() {
      if (!this.audio) {
        this.initAudio();
      }

      if (this.isPlaying) {
        this.audio.pause();
      } else {
        this.audio.play();
      }
      this.isPlaying = !this.isPlaying;
    },

    // Charger la chanson suivante
    nextSong() {
      this.axios.get(`${this.requestHttp}next-audio/${this.currentSong.id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        }
      }).then(({ data }) => {
        if (data.success) {
          this.currentSong = data.data;
          this.initAudio();
          this.isPlaying = true; // Redémarrer la chanson automatiquement
        } else {
          console.error('Aucune chanson suivante trouvée');
        }
      }).catch(error => {
        console.error('Erreur lors du chargement de la chanson suivante:', error);
      });
    },

    // Charger la chanson précédente
    prevSong() {
      this.axios.get(`${this.requestHttp}prev-audio/${this.currentSong.id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        }
      }).then(({ data }) => {
        if (data.success) {
          this.currentSong = data.data;
          this.initAudio();
          this.isPlaying = true; // Redémarrer la chanson automatiquement
        } else {
          console.error('Aucune chanson précédente trouvée');
        }
      }).catch(error => {
        console.error('Erreur lors du chargement de la chanson précédente:', error);
      });
    },
  },
  beforeDestroy() {
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
    }
  },

  computed: {
    requestHttp() {
      return this.$store.state.api
    },
    requestFile() {
      return this.$store.state.apifile
    },
  }
};
</script>

<style scoped>
@keyframes marquee {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.animate-marquee {
  animation: marquee linear infinite;
}
</style>
